<template>
  <section>
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">Descargar reporte {{dailyReport ? dailyReport.report_date : ''}}</p>
      </header>
      <section class="modal-card-body">
        <!-- <div class="table-container"> -->
          <table 
            v-for="(stablishment, index) in tableData.stablishments"
            :key="stablishment.id"
            :ref="`tableReport-${stablishment.id}`"
            class="table is-striped is-bordered is-narrow is-fullwidth"
           >
            <thead>
              <tr class="header">
                <th width="450" style="border: 0px solid;"></th>
                <th class="col-header" colspan="8">{{ stablishment.name }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="border: 0px solid"></td>
                <td><b>HABILITADAS</b></td>
                <td><b>DISPONIBLE</b></td>
                <td><b>OCUPADAS</b></td>
                <td><b>BLOQUEADAS</b></td>
                <td><b>VENT. DISPONIBLE</b></td>
                <td><b>VENT. OCUPADO</b></td>
                <td><b>COVID19</b></td>
                <td><b>%OCUP.</b></td>
              </tr>
              <tr v-for="dataCriticalBed in tableData.dataCriticalBeds" :key="dataCriticalBed.subcategorization.id">
                <td >{{dataCriticalBed.subcategorization.name}}</td>
                <td>{{dataCriticalBed.stablishments[index].total == 0 ? '-' : dataCriticalBed.stablishments[index].enabled}}</td>
                <td>{{dataCriticalBed.stablishments[index].total == 0 ? '-' : dataCriticalBed.stablishments[index].enabled - dataCriticalBed.stablishments[index].occupied}}</td>
                <td>{{dataCriticalBed.stablishments[index].total == 0 ? '-' : dataCriticalBed.stablishments[index].occupied}}</td>
                <td>{{dataCriticalBed.stablishments[index].total == 0 ? '-' : dataCriticalBed.stablishments[index].blocked}}</td>
                <td>{{dataCriticalBed.stablishments[index].hasVentilator == 0  || dataCriticalBed.stablishments[index].hasVentilator == undefined ? '-' : dataCriticalBed.stablishments[index].hasVentilator - dataCriticalBed.stablishments[index].ventilator}}</td>
                <td>{{dataCriticalBed.stablishments[index].hasVentilator == 0 || dataCriticalBed.stablishments[index].hasVentilator == undefined ? '-' : dataCriticalBed.stablishments[index].ventilator}}</td>
                <td>{{dataCriticalBed.stablishments[index].total == 0 ? '-' : dataCriticalBed.stablishments[index].covid19}}</td>
                <td>{{dataCriticalBed.stablishments[index].total == 0 ? '-' : `${dataCriticalBed.stablishments[index].occupation} %`}}</td>
              </tr>
              <tr class="col-subheader">
                <td ><b>% Camas Críticas</b></td>
                <td>{{tableData.stablishmentDataCritical[index].total == 0 ? '-' : tableData.stablishmentDataCritical[index].enabled}}</td>
                <td>{{tableData.stablishmentDataCritical[index].total == 0 ? '-' : tableData.stablishmentDataCritical[index].enabled - tableData.stablishmentDataCritical[index].occupied}}</td>
                <td>{{tableData.stablishmentDataCritical[index].total == 0 ? '-' : tableData.stablishmentDataCritical[index].occupied}}</td>
                <td>{{tableData.stablishmentDataCritical[index].total == 0 ? '-' : tableData.stablishmentDataCritical[index].blocked}}</td>
                <td>{{tableData.stablishmentDataCritical[index].hasVentilator == 0  || tableData.stablishmentDataCritical[index].hasVentilator == undefined ? '-' : tableData.stablishmentDataCritical[index].hasVentilator - tableData.stablishmentDataCritical[index].ventilator}}</td>
                <td>{{tableData.stablishmentDataCritical[index].hasVentilator == 0 || tableData.stablishmentDataCritical[index].hasVentilator == undefined ? '-' : tableData.stablishmentDataCritical[index].ventilator}}</td>
                <td>{{tableData.stablishmentDataCritical[index].total == 0 ? '-' : tableData.stablishmentDataCritical[index].covid19}}</td>
                <td :class="tableData.stablishmentDataCritical[index].total == 0 ? '' : 'col-percentage'">{{ tableData.stablishmentDataCritical[index].total == 0 ? '-' : `${tableData.stablishmentDataCritical[index].occupation} %` }}</td>
              </tr>
              <tr v-for="dataMediumBed in tableData.dataMediumBeds" :key="dataMediumBed.subcategorization.id">
                <td >{{dataMediumBed.subcategorization.name}}</td>
                <td>{{dataMediumBed.stablishments[index].total == 0 ? '-' : dataMediumBed.stablishments[index].enabled}}</td>
                <td>{{dataMediumBed.stablishments[index].total == 0 ? '-' : dataMediumBed.stablishments[index].enabled - dataMediumBed.stablishments[index].occupied}}</td>
                <td>{{dataMediumBed.stablishments[index].total == 0 ? '-' : dataMediumBed.stablishments[index].occupied}}</td>
                <td>{{dataMediumBed.stablishments[index].total == 0 ? '-' : dataMediumBed.stablishments[index].blocked}}</td>
                <td>{{dataMediumBed.stablishments[index].hasVentilator == 0  || dataMediumBed.stablishments[index].hasVentilator == undefined ? '-' : dataMediumBed.stablishments[index].hasVentilator - dataMediumBed.stablishments[index].ventilator}}</td>
                <td>{{dataMediumBed.stablishments[index].hasVentilator == 0 || dataMediumBed.stablishments[index].hasVentilator == undefined ? '-' : dataMediumBed.stablishments[index].ventilator}}</td>
                <td>{{dataMediumBed.stablishments[index].total == 0 ? '-' : dataMediumBed.stablishments[index].covid19}}</td>
                <td>{{dataMediumBed.stablishments[index].total == 0 ? '-' : `${dataMediumBed.stablishments[index].occupation} %`}}</td>
              </tr>
              <tr class="col-subheader">
                <td ><b>% Camas Medias</b></td>
                <td>{{tableData.stablishmentDataMedium[index].total == 0 ? '-' : tableData.stablishmentDataMedium[index].enabled}}</td>
                <td>{{tableData.stablishmentDataMedium[index].total == 0 ? '-' : tableData.stablishmentDataMedium[index].enabled - tableData.stablishmentDataMedium[index].occupied}}</td>
                <td>{{tableData.stablishmentDataMedium[index].total == 0 ? '-' : tableData.stablishmentDataMedium[index].occupied}}</td>
                <td>{{tableData.stablishmentDataMedium[index].total == 0 ? '-' : tableData.stablishmentDataMedium[index].blocked}}</td>
                <td>{{tableData.stablishmentDataMedium[index].hasVentilator == 0  || tableData.stablishmentDataMedium[index].hasVentilator == undefined ? '-' : tableData.stablishmentDataMedium[index].hasVentilator - tableData.stablishmentDataMedium[index].ventilator}}</td>
                <td>{{tableData.stablishmentDataMedium[index].hasVentilator == 0 || tableData.stablishmentDataMedium[index].hasVentilator == undefined ? '-' : tableData.stablishmentDataMedium[index].ventilator}}</td>
                <td>{{tableData.stablishmentDataMedium[index].total == 0 ? '-' : tableData.stablishmentDataMedium[index].covid19}}</td>
                <td :class="tableData.stablishmentDataMedium[index].total == 0 ? '' : 'col-percentage'">{{ tableData.stablishmentDataMedium[index].total == 0 ? '-' : `${tableData.stablishmentDataMedium[index].occupation} %` }}</td>
              </tr>
              <tr v-for="dataBasicBed in tableData.dataBasicBeds" :key="dataBasicBed.subcategorization.id">
                <td >{{dataBasicBed.subcategorization.name}}</td>
                <td>{{dataBasicBed.stablishments[index].total == 0 ? '-' : dataBasicBed.stablishments[index].enabled}}</td>
                <td>{{dataBasicBed.stablishments[index].total == 0 ? '-' : dataBasicBed.stablishments[index].enabled - dataBasicBed.stablishments[index].occupied}}</td>
                <td>{{dataBasicBed.stablishments[index].total == 0 ? '-' : dataBasicBed.stablishments[index].occupied}}</td>
                <td>{{dataBasicBed.stablishments[index].total == 0 ? '-' : dataBasicBed.stablishments[index].blocked}}</td>
                <td>{{dataBasicBed.stablishments[index].hasVentilator == 0  || dataBasicBed.stablishments[index].hasVentilator == undefined ? '-' : dataBasicBed.stablishments[index].hasVentilator - dataBasicBed.stablishments[index].ventilator}}</td>
                <td>{{dataBasicBed.stablishments[index].hasVentilator == 0 || dataBasicBed.stablishments[index].hasVentilator == undefined ? '-' : dataBasicBed.stablishments[index].ventilator}}</td>
                <td>{{dataBasicBed.stablishments[index].total == 0 ? '-' : dataBasicBed.stablishments[index].covid19}}</td>
                <td>{{dataBasicBed.stablishments[index].total == 0 ? '-' : `${dataBasicBed.stablishments[index].occupation} %`}}</td>
              </tr>
              <tr class="col-subheader">
                <td ><b>% Camas Báicas</b></td>
                <td>{{tableData.stablishmentDataBasic[index].total == 0 ? '-' : tableData.stablishmentDataBasic[index].enabled}}</td>
                <td>{{tableData.stablishmentDataBasic[index].total == 0 ? '-' : tableData.stablishmentDataBasic[index].enabled - tableData.stablishmentDataBasic[index].occupied}}</td>
                <td>{{tableData.stablishmentDataBasic[index].total == 0 ? '-' : tableData.stablishmentDataBasic[index].occupied}}</td>
                <td>{{tableData.stablishmentDataBasic[index].total == 0 ? '-' : tableData.stablishmentDataBasic[index].blocked}}</td>
                <td>{{tableData.stablishmentDataBasic[index].hasVentilator == 0  || tableData.stablishmentDataBasic[index].hasVentilator == undefined ? '-' : tableData.stablishmentDataBasic[index].hasVentilator - tableData.stablishmentDataBasic[index].ventilator}}</td>
                <td>{{tableData.stablishmentDataBasic[index].hasVentilator == 0 || tableData.stablishmentDataBasic[index].hasVentilator == undefined ? '-' : tableData.stablishmentDataBasic[index].ventilator}}</td>
                <td>{{tableData.stablishmentDataBasic[index].total == 0 ? '-' : tableData.stablishmentDataBasic[index].covid19}}</td>
                <td :class="tableData.stablishmentDataBasic[index].total == 0 ? '' : 'col-percentage'">{{ tableData.stablishmentDataBasic[index].total == 0 ? '-' : `${tableData.stablishmentDataMedium[index].occupation} %` }}</td>
              </tr>
            </tbody>
          </table>
          <table v-if="tableData.summaryTable && !this.stablishmentId" ref="summaryTable" class="table is-striped is-bordered is-narrow is-fullwidth">
            <thead>
              <tr class="header has-text-centered">
                <th style="border: 0px solid;"></th>
                <th class="col-header" colspan="6">CRÍTICAS</th>
                <th class="col-header" colspan="2" rowspan="2">% OCUPACIÓN UCI/UTI</th>
                <th class="col-header" colspan="2">VENTILADORES</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowspan="2">HOSPITAL</td>
                <td colspan="2">Habilitadas</td>
                <td colspan="2">Ocupadas</td>
                <td colspan="2">Disponibles</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>UCI</td>
                <td>UTI</td>
                <td>UCI</td>
                <td>UTI</td>
                <td>UCI</td>
                <td>UTI</td>
                <td>UCI</td>
                <td>UTI</td>
                <td>OCUPADOS</td>
                <td>DISPONIBLES</td>
              </tr>
              <tr v-for="(row, index) in tableData.summaryTable.slice(0, tableData.summaryTable.length-1)" :key="index">
                <td>{{row.name}}</td>
                <td>{{row.uciEnabled}}</td>
                <td>{{row.utiEnabled}}</td>
                <td>{{row.uciOccupied}}</td>
                <td>{{row.utiOccupied}}</td>
                <td>{{row.uciAvailable}}</td>
                <td>{{row.utiAvailable}}</td>
                <td>{{ row.uciEnabled == 0 ? 0 : (row.uciOccupied*100/row.uciEnabled).toFixed(2)  }}%</td>
                <td>{{ row.utiEnabled == 0 ? 0 : (row.utiOccupied*100/row.utiEnabled).toFixed(2)  }}%</td>
                <td>{{row.occupiedVentilators}}</td>
                <td>{{row.availableVentilators}}</td>
              </tr>
              <tr>
                <td><b>{{tableData.summaryTable[tableData.summaryTable.length-1].name}}</b></td>
                <td colspan="2" class="has-text-centered"><b>{{tableData.summaryTable[tableData.summaryTable.length-1].uciEnabled + tableData.summaryTable[tableData.summaryTable.length-1].utiEnabled}}</b></td>
                <td colspan="2" class="has-text-centered"><b>{{tableData.summaryTable[tableData.summaryTable.length-1].uciOccupied + tableData.summaryTable[tableData.summaryTable.length-1].utiOccupied}}</b></td>
                <td colspan="2" class="has-text-centered"><b>{{tableData.summaryTable[tableData.summaryTable.length-1].uciAvailable + tableData.summaryTable[tableData.summaryTable.length-1].utiAvailable}}</b></td>
                <td colspan="2"></td>
                <td class="has-text-centered"><b>{{tableData.summaryTable[tableData.summaryTable.length-1].occupiedVentilators}}</b></td>
                <td class="has-text-centered"><b>{{tableData.summaryTable[tableData.summaryTable.length-1].availableVentilators}}</b></td>
              </tr>
              <tr class="has-text-centered">
                <td colspan="3">Ocupación</td>
                <td colspan="4" class="has-text-centered"><b>{{calculateCriticOcupation()}}%</b></td>
                <td colspan="2"></td>
                <td colspan="2" class="has-text-centered"><b>{{calculateVentilatorOcupation()}}%</b></td>
              </tr>
            </tbody>
          </table>
          <div class="mt-4" v-if="dailyReport">
            <h5 class="is-size-5">Observaciones</h5>
            <hr class="mt-1 mb-1">
            <p>{{dailyReport.observations ? dailyReport.observations : 'Sin observaciones'}}</p>
          </div>
        <!-- </div> -->
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">
          Cerrar
        </button>
        <b-button class="button is-primary" :loading="loadingButtonReportPdf" @click="generatePdf">
          Descargar pdf
        </b-button>
      </footer>
    </div>
  </section>
</template>

<script>
import html2canvas from 'html2canvas';
import moment from "moment";
export default {
  props: ["tableData", "stablishmentId", "dailyReport"],
  data() {
    return {
      loadingButtonReportPdf: false
    }
  },
  methods: {
    calculateVentilatorOcupation() {
      let totalOccupied = this.tableData.summaryTable[this.tableData.summaryTable.length-1].occupiedVentilators;
      let totalAvailable = this.tableData.summaryTable[this.tableData.summaryTable.length-1].availableVentilators;
      let total = totalOccupied + totalAvailable;
      let occupation = total == 0 ? 0 : ((totalOccupied*100)/total).toFixed(2);
      return occupation;
    },
    calculateCriticOcupation() {
      let totalOccupied = this.tableData.summaryTable[this.tableData.summaryTable.length-1].uciOccupied + this.tableData.summaryTable[this.tableData.summaryTable.length-1].utiOccupied;
      let totalAvailable = this.tableData.summaryTable[this.tableData.summaryTable.length-1].uciAvailable + this.tableData.summaryTable[this.tableData.summaryTable.length-1].utiAvailable;
      let total = totalOccupied + totalAvailable;
      let occupation = total == 0 ? 0 : ((totalOccupied*100)/total).toFixed(2);
      return occupation;
    },
    async generatePdf() {
      this.loadingButtonReportPdf = true;
      let observations = [];
      // let pageHeight = 350;
      if (this.dailyReport) {
        observations = [
          {
            text: `Observaciones`,
            style: "subHeader",
            bold: true,
            marginBottom: 10,
            marginTop: 20
          },
          {
            text: `${this.dailyReport.observations ? this.dailyReport.observations : 'Sin observaciones'}`,
          },
        ];
        // pageHeight = 450;
      }
      let canvasSummary;
      if(this.tableData.summaryTable && !this.stablishmentId) {
        await html2canvas(this.$refs.summaryTable).then((canvas) => {
          canvasSummary = canvas.toDataURL("image/png");
          canvasSummary = {
            image: canvasSummary,
            // width: largeReportwidth,
            width: 500
            // marginBottom: 20,
            // pageBreak: report.pageBreak
          }
        });
      }
      let hospitalReports = [];
      for (let i = 0; i < this.tableData.stablishments.length; i++) {
        const stablishment = this.tableData.stablishments[i];
        console.log(this.$refs[`tableReport-${stablishment.id}`][0]);
        let canvasImage;
        await html2canvas(this.$refs[`tableReport-${stablishment.id}`][0]).then((canvas) => {
          canvasImage = canvas.toDataURL("image/png");
          let pageBreak;
          if ([1,2,4,6].includes(stablishment.id)) {
            pageBreak = "after";
          }
          canvasImage = {
            image: canvasImage,
            width: 500,
            pageBreak: pageBreak,
            marginBottom: 20
            // pageBreak: "after"
          };
          hospitalReports.push(canvasImage);
        }); 
      }
      // html2canvas(this.$refs.tableReport).then((canvas) => {
        console.log(hospitalReports);
        var pdfMake = require("pdfmake/build/pdfmake.js");
        if (pdfMake.vfs == undefined) {
          var pdfFonts = require("pdfmake/build/vfs_fonts.js");
          pdfMake.vfs = pdfFonts.pdfMake.vfs;
        
        }
        let largeReportOptions;
        // let largeReportwidth = !this.stablishmentId ? 728 : 480;
        // if (!this.stablishmentId) {
        //   largeReportOptions = {
        //     pageSize: {
        //       width: 800,
        //       height: pageHeight
        //     },
        //     pageOrientation: 'landscape',
        //   }
        // }
        var docDefinition = {
          pageMargins: [40, 40, 40, 45],
          // pageSize: {
          //   width: 800,
          //   height: 350
          // },
          // pageOrientation: 'landscape',
          ...largeReportOptions,
          content: [
            {
              text: `Reporte gestión de camas ${this.dailyReport ? this.dailyReport.report_date : moment().format("YYYY-MM-DD HH:mm")}`,
              style: "header",
              bold: true,
              marginBottom: 15,
            },
            ...hospitalReports,
            // {
            //   image: canvas.toDataURL("image/png"),
            //   width: largeReportwidth,
              // marginBottom: 20,
              // pageBreak: report.pageBreak
            // },
            canvasSummary,
            ...observations
          ],
          styles: {
            tableExample: {
              alignment: "justify",
              margin: [0, -150, 0, 15],
            },
            toTheRight: {
              alignment: "right",
            },
            header: {
              fontSize: 14,
              alignment: "left",
              bold: true,
            },
            subHeader: {
              fontSize: 14,
              alignment: "left",
              bold: true,
            },
          },
        };
        let pdfName = `Reporte ${this.dailyReport ? this.dailyReport.report_date : moment().format("YYYY-MM-DD HH:mm")}.pdf`;
        pdfMake.createPdf(docDefinition).download(pdfName, () => {
          this.loadingButtonReportPdf = false;
        });
      // });
    },
  }
};
</script>

<style scoped>
  .col-header {
    background-color: #3c3ebc;
    color: #f0f0f0;
  }
  .col-subheader {
    background-color: #dcdcff !important;
  }
  .col-percentage {
    background-color: #c3c3ff !important;
  }
</style>